export default "__VITE_ASSET__vGJDtINI__"